import type { OpenContent } from './typings'

export const openContentActionCreator = (
  payload: HTMLButtonElement,
): OpenContent => ({
  type: 'activities/openContent',
  payload,
})
